import { Dropdown, Button, Badge, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import DeleteFunction from "./deleteFunction";
import toast from "react-hot-toast";
import { Tooltip } from "antd";


import { DateToLocale, ToFirstCapital } from "../Utils/helpers";

export const columnsUsers = (currentPage, pageSize, handleSubscriptionToggle) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "User Id",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "name",
    key: "user_name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
    render: (number, record) =>
      number ? `${record.country_code || ""} ${number}` : "N/A",
  },
  {
    title: "Verification Status",
    align: "center",
    dataIndex: "is_contact_number_verified",
    key: "is_contact_number_verified",
    render: (record) => (record ? "Verified" : "Un-Verified"),
  },
  {
    title: "Properties Booked",
    align: "center",
    dataIndex: "properties",
    key: "properties",
    render: (record) => record?.length || "0",
  },
  {
    title: "Documents",
    align: "center",
    dataIndex: "documents",
    key: "documents",
    ellipsis: false,
    render: (documents) => {
      if (!Array.isArray(documents) || documents.length === 0) {
        return <p style={{ color: "red" }}>No documents</p>;
      }
      return (
        <div style={{ width: "100%", cursor: "pointer" }}>
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu>
                {documents.map((doc, index) => (
                  <Menu.Item key={index}>
                    <a href={doc.url} target="_blank" rel="noopener noreferrer">
                      {doc.name}
                    </a>
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <span style={{ color: "blue" }}>View Documents</span>
          </Dropdown>
        </div>
      );
    },
  },
  {
    title: "Sign Up Date",
    align: "center",
    dataIndex: "created_at",
    key: "created",
    render: (record) => (record ? new Date(record).toLocaleString() : ""),
  },
  {
    title: "Email Subscribe",
    align: "center",
    dataIndex: "email_subscribe",
    key: "email_subscribe",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 500,
          border: `1px solid ${status === "subscribed" ? "#b7eb8f" : "#ffccc7"}`,
          background: status === "subscribed" ? "#f6ffed" : "#fff2f0",
          color: status === "subscribed" ? "#52c41a" : "#ff4d4f",
        }}>
        {status === "subscribed" ? "Subscribed" : "Unsubscribed"}
      </span>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "unblock" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/manage_users/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item
              key="subscribe"
              onClick={() => handleSubscriptionToggle(record._id, "subscribed")}
              disabled={record.email_subscribe === "subscribed"}
              style={{
                color:
                  record.email_subscribe === "subscribed"
                    ? "#bfbfbf"
                    : "#52c41a",
              }}
            >
              Subscribe
            </Menu.Item>
            <Menu.Item
              key="unsubscribe"
              onClick={() => handleSubscriptionToggle(record._id, "unsubscribed")}
              disabled={record.email_subscribe === "unsubscribed"}
              style={{
                color:
                  record.email_subscribe === "unsubscribed"
                    ? "#bfbfbf"
                    : "#ff4d4f",
              }}
            >
              Unsubscribe
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnPlans = () => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "plan_name",
    key: "plan_name",
  },
  {
    title: "planId",
    align: "center",
    dataIndex: "plan_id",
    key: "plan_id",
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
  },
  // {
  //   title: "Plan Type",
  //   align: "center",
  //   dataIndex: "plan_type",
  //   key: "plan_type",
  // },
  {
    title: "Plan Interval Type",
    align: "center",
    dataIndex: "period",
    key: "period",
  },

  {
    title: "Plan Interval",
    align: "center",
    dataIndex: "interval",
    key: "interval",
  },

  {
    title: "Created",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Actions",
    align: "center",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/Plan/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsState = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "state_name",
    key: "state_name",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "active" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/state-list/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            <Menu.Item key="view">
              <Link to={`/city/${record._id}`}>View Cities</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCountry = (canEdit) => [
  // for the antD table headers
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country Name",
    dataIndex: "country_name",
    align: "center",
    key: "country_name_withoutspace",
  },
  {
    title: "Country Code",
    dataIndex: "country_code",
    align: "center",
    key: "country_code",
  },
  {
    title: "Country's Language",
    dataIndex: "country_language_name",
    key: "country_language_name",
    align: "center",
  },
  {
    title: "Language Code",
    dataIndex: "country_language_code",
    key: "country_language_code",
    align: "center",
  },
  {
    title: "Country's Currency",
    dataIndex: "country_currency",
    key: "country_currency",
    align: "center",
  },
  {
    title: "Currency's Symbol",
    dataIndex: "country_currency_symbol",
    key: "country_currency_symbol",
    align: "center",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/country/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            <Menu.Item key="view_states">
              <Link to={`/state-list/${record._id}`}>View States</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/country/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCity = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "city_name",
    key: "city_name",
  },
  {
    title: " Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (image) => {
      return image ? (
        <img
          src={image}
          alt="City"
          style={{
            width: 100,
            height: 50,
            objectFit: "cover",
            borderRadius: 4,
          }}
        />
      ) : (
        <span style={{ color: "#aaa" }}>N/A</span>
      );
    },
  },
  {
    title: "Vr Home Visit Available",
    align: "center",
    dataIndex: "is_vr_home_visit_available",
    key: "is_vr_home_visit_available",
    render: (is_vr_home_visit_available) => {
      return is_vr_home_visit_available ? (
        <span className="span-class-true">Available</span>
      ) : (
        <span className="span-class-false">Un-Available</span>
      );
    },
  },
  {
    title: "Popularity Status",
    align: "center",
    dataIndex: "is_popular",
    key: "is_popular",
    render: (popular) => {
      return popular ? (
        <span className="span-class-true">Popular</span>
      ) : (
        <span className="span-class-false">Non-Popular</span>
      );
    },
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={status?.charAt(0).toUpperCase() + status?.slice(1)}
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            {/* <Menu.Item key="View">
              <Link to={`/city/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/city/Edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAmenities = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Icon",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => {
      return <img src={record} alt="" style={{ maxWidth: "50px" }}></img>;
    },
  },
  {
    title: "Amenity For",
    align: "center",
    dataIndex: "amenities_for",
    key: "category",
    render: (amenity) => {
      return amenity.charAt(0).toUpperCase() + amenity.slice(1);
    },
  },
  {
    title: "Category",
    align: "center",
    dataIndex: "project_type",
    key: "project_type",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link
                state={{ amenityName: record.name }}
                to={`/amenities/view/${record._id}`}
              >
                View
              </Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link
                  state={{ amenityName: record.name }}
                  to={`/amenities/edit/${record._id}`}
                >
                  Edit
                </Link>
              </Menu.Item>
            }
            <Menu.Item
              key="delete"
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/amenity/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBuilders = [
  { title: "Sr No.", render: (_, __, index) => index + 1 },
  {
    title: "Builder Name",
    align: "center",
    dataIndex: "brand_name",
    key: "brand_name",
  },
  {
    title: "Email Address",
    align: "center",
    key: "primary_email",
    dataIndex: "primary_email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "primary_contact_number",
    dataIndex: "primary_contact_number",
  },
  {
    title: "Builder ID",
    align: "center",
    key: "builder_id",
    dataIndex: "builder_id",
  },
  {
    title: "Authorised Person",
    align: "center",
    key: "authorized_persons",
    dataIndex: "authorized_persons",
    render: (authorized_persons) =>
      authorized_persons.length > 0
        ? authorized_persons.map((person) => person.name).join(", ")
        : "Not Available",
  },
  {
    title: "Total Projects",
    align: "center",
    dataIndex: "total_projects",
  },
  {
    title: "Live Projects",
    align: "center",
    dataIndex: "live_projects",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (account_status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={account_status === "approved" ? "green" : "red"}
          text={
            account_status?.charAt(0)?.toUpperCase() + account_status?.slice(1)
          }
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    dataIndex: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/builders/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsKiosk = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Kiosk ID",
    align: "center",
    key: "builder_id",
    dataIndex: "builder_id",
  },
  {
    title: "Organization Name",
    align: "center",
    dataIndex: "organization_name",
    key: "organization_name",
  },
  {
    title: "Email Address",
    align: "center",
    key: "primary_email",
    dataIndex: "primary_email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "primary_contact_number",
    render: (_, record) =>
      record
        ? `${record.primary_country_code || ""} ${record.primary_contact_number || ""}`.trim()
        : "N/A",
  },
  // {
  //   title: "Authorised Person",
  //   align: "center",
  //   key: "authorized_persons",
  //   dataIndex: "authorized_persons",
  //   render: (authorized_persons) =>
  //     authorized_persons.length > 0
  //       ? authorized_persons.map((person) => person.name).join(", ")
  //       : "Not Available",
  // },
  // {
  //   title: "Total Projects",
  //   align: "center",
  //   dataIndex: "total_projects",
  // },
  // {
  //   title: "Live Projects",
  //   align: "center",
  //   dataIndex: "live_projects",
  // },
  {
    title: "Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (account_status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            account_status === "approved"
              ? "green"
              : account_status === "requested"
                ? "orange"
                : "red"
          }
          text={
            account_status?.charAt(0)?.toUpperCase() + account_status?.slice(1)
          }
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    dataIndex: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/kiosk/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsLocality = (currentPage, pageSize, handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "City",
    align: "center",
    key: "city_name",
    render: (_, record) => record.city?.city_name || "N/A",
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Short Address",
    align: "center",
    dataIndex: "short_address",
    key: "short_address",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Google Maps",
    align: "center",
    key: "google_url",
    render: (_, record) => (
      <a
        href={record.google_url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1890ff' }}
      >
        View Map
      </a>
    ),
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => {
      const isActive = status === "active";
      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "10px",
            backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
            border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
            color: isActive ? "#52c41a" : "#ff4d4f",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
              marginRight: "6px",
            }}
          />
          {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
        </div>
      );
    },
  },
  // {
  //   title: "Created",
  //   align: "center",
  //   key: "created_at",
  //   render: (_, record) => 
  //     record.created_at ? new Date(record.created_at).toLocaleDateString() : "N/A",
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">View
              <Link to={`/locality/view/${record._id}`}></Link>
            </Menu.Item>
            <Menu.Item key="edit">Edit

              <Link to={`/locality/edit/${record._id}`}></Link>
            </Menu.Item>
            {record.status !== "active" && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
                style={{ color: "green" }}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
                style={{ color: "red" }}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button
          shape="square"
          icon={<EllipsisOutlined />}
        />
      </Dropdown >
    ),
  },
];


export const columnsCollections = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },

  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.image}
        key={index}
        style={{ maxHeight: "30px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="Icon"
      ></img>
    ),
  },
  {
    title: "3D Icon",
    dataIndex: "3dIcon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.three_d_icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="three_d_icon"
      ></img>
    ),
  },
  // {
  //   title: "Banner Title",
  //   dataIndex: "banner_title",
  //   key: "banner_title",
  //   align: "center",
  //   render: (text) => (text && text.trim() !== "" ? text : "N/A")
  // },
  // {
  //   title: "Banner Image",
  //   dataIndex: "banner_image",
  //   key: "data",
  //   align: "center",
  //   render: (_, record, index) => (
  //     <img
  //       src={record?.banner_image}
  //       key={index}
  //       style={{ maxHeight: "30px" }}
  //       alt="Icon"
  //     ></img>
  //   ),
  // },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/collections/view/${record._id}`}>View</Link>
            </Menu.Item>
            {(canEdit &&
              <Menu.Item key="edit">
                <Link to={`/collections/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
            {/* <Menu.Item
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
              key="delete"
              style={{ color: "red" }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsSubCollections = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Sub Collections Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "icon",
    align: "center",
    render: (record) => (
      <img src={record} alt="" style={{ maxWidth: "50px" }} />
    ),
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "3D Icon",
    dataIndex: "three_d_icon",
    key: "three_d_icon",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={status?.charAt(0).toUpperCase() + status?.slice(1)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Link to={`/collections/view/${record._id}`}>
              <Menu.Item>View</Menu.Item>
            </Link> */}
            {(canEdit &&
              <Link to={`/collections/${record._id}/sub/edit`}>
                <Menu.Item>Edit</Menu.Item>
              </Link>
            )}
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCoupons = (handleStatusChange) => [
  {
    title: "Sr. No.",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Coupon Id",
    dataIndex: "code",
    align: "center",
    key: "country_name_withoutspace",
  },
  {
    title: "Discount Type",
    dataIndex: "discount_type",
    align: "center",
    key: "discount_type",
    render: (text) => ToFirstCapital(text),
  },
  {
    title: "Coupon Value",
    dataIndex: "discounts",
    key: "coupon_value",
    align: "center",
    render: (_, record) => {
      const units = Array.isArray(record?.units) ? record.units : [];
      const discounts = Array.isArray(record?.discounts)
        ? record.discounts
        : [];

      if (units.length === 0) {
        // Show global discount_type and value from root record
        const dt = record.discount_type
          ? ToFirstCapital(record.discount_type)
          : "";
        const val = record.value ?? "";
        return (
          <div>
            {dt} {val}
          </div>
        );
      }

      // units exist, show discounts array details grouped by unit
      if (discounts.length === 0) return null;

      return (
        <>
          {discounts.map((d, i) => (
            <div key={i} style={{ marginBottom: "4px" }}>
              <strong>{d?.unit || "Unit"}:</strong>{" "}
              {d.discount_type ? ToFirstCapital(d.discount_type) : ""}{" "}
              {d.value ?? ""}
              {d.discount_in === "percent" ? "%" : "₹"}
              {d.discount_type === "upto" && d.value_upto_show > 0 && (
                <> (Upto {d.value_upto_show})</>
              )}
            </div>
          ))}
        </>
      );
    },
  },
  {
    title: "Project Name",
    dataIndex: "project",
    key: "project",
    align: "center",
    render: (project) => {
      return project?.project_name || "";
    },
  },
  {
    title: "No. of Usages",
    dataIndex: "no_of_usage",
    key: "no_of_usage",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Valid From",
    dataIndex: "start_date",
    key: "start_date",
    align: "center",
    render: (text) => {
      const d = new Date(text);
      const date = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
      return date;
    },
  },
  {
    title: "Expiry Date",
    dataIndex: "end_date",
    key: "end_date",
    align: "center",
    render: (text) => {
      const d = new Date(text);
      const date = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
      return date;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Primary Status",
    dataIndex: "set_primary",
    align: "center",
    key: "set_primary",
    render: (set_primary) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={set_primary ? "blue" : "gray"}
          text={set_primary ? "Primary" : "Not Primary"}
        />
      </span>
    ),
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Show Active only if status is NOT active */}
            {record.status !== "active" && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}

            {!record.set_primary && (
              <Menu.Item
                key="Primary"
                onClick={() => handleStatusChange(record, "primary")}
              >
                Primary
              </Menu.Item>
            )}

            {record.set_primary && (
              <Menu.Item
                key="Remove Primary"
                onClick={() => handleStatusChange(record, "remove-primary")}
              >
                Remove Primary
              </Menu.Item>
            )}
            <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/coupon/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsEvents = [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Event Id",
    align: "center",
    dataIndex: "event_id",
  },
  {
    title: "Event Type",
    align: "center",
    dataIndex: "type",
    render: (record) => record?.toUpperCase(),
  },
  {
    title: "Event Name",
    align: "center",
    dataIndex: "event_name",
    key: "event_name", render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Start Date",
    align: "center",
    key: "start_date",
    dataIndex: "start_date",
  },
  {
    title: "Start Time",
    align: "center",
    key: "start_time",
    dataIndex: "start_time",
    render: (value) => (value ? value : "N/A"),
  },
  {
    title: "End Date",
    align: "center",
    key: "end_date",
    dataIndex: "end_date",
  },
  {
    title: "End Time",
    align: "center",
    dataIndex: "end_time",
    render: (value) => (value ? value : "N/A"),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "active" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/event/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/event/edit/${record._id}`}>Edit</Link>
            </Menu.Item>

            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/event/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsProjects = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_name",
  },
  {
    title: "Project Type",
    align: "center",
    dataIndex: "project_type",
    render: (record) => (record ? record.name : ""),
  },
  {
    title: "Location",
    align: "center",
    dataIndex: "street_address",
    ellipsis: true,
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Total Bookings",
    align: "center",
    dataIndex: "booking_count", // match the backend field
    key: "booking_count",
    render: (text) => text || 0, // just in case
  },

  // {
  //   title: "Phase",
  //   align: "center",
  //   dataIndex: "phases",
  //   render: (phases) =>
  //     Array.isArray(phases) && phases.length > 0 ? phases.length : "No Phase",
  // },
  // {
  //   title: "Total Bookings",
  //   align: "center",
  //   dataIndex: "units",
  //   render: (units) =>
  //     Array.isArray(units) && units.length > 0 ? units.length : "No Bookings",
  // },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "approved" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/manage_projects/view/${record._id}`}>View</Link>
            </Menu.Item>

            <Menu.Item key="View_catalogue">
              <Link to={`/manage_projects/view/catalogue/${record._id}`}>
                View Project Catalogue
              </Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

const getDaysSince = (dateString) => {
  if (!dateString) return "-";
  const createdDate = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - createdDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const ReferralLists = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: ["booking", "booking_id"],
    render: (booking_id, record) => record.booking?.booking_id || "",
  },
  {
    title: "Referral From Name",
    align: "center",
    dataIndex: ["referral_from_user", "name"],
    render: (name, record) => record.referral_from_user?.name || "N/A",
  },
  {
    title: "Referral To Name",
    align: "center",
    dataIndex: ["referral_to_user", "name"],
    render: (name, record) => record.referral_to_user?.name || "N/A",
  },
  {
    title: "Referral Amount",
    align: "center",
    dataIndex: "referral_amount",
    ellipsis: true,
  },
  {
    title: "Created At Date",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (date, record) => DateToLocale(record.booking?.created_at),
  },
  {
    title: "Days Since Created",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (date) => {
      const days = getDaysSince(date);
      return days === 0 ? "Today" : `${days} day${days > 1 ? "s" : ""} ago`;
    },
  },
  {
    title: "Reward Days Left",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (created_at) => {
      if (!created_at) return "";
      const rewardEndDate = new Date(created_at);
      rewardEndDate.setDate(rewardEndDate.getDate() + 45);

      const today = new Date();
      const diffTime = rewardEndDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays <= 0) return "Ended";
      if (diffDays === 1) return "1 day left";
      return `${diffDays} days left`;
    },
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => {
      const statusColors = {
        ongoing: "blue",
        paid: "green",
        closed: "gray",
        cancelled: "red",
      };
      const color = statusColors[status] || "default";
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge color={color} text={ToFirstCapital(status)} />
        </span>
      );
    },
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/referrals/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const SignUpReferralLists = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
    render: (name) => name || "",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
    render: (email) => email || "",
  },
  {
    title: "User ID",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
    render: (id) => id || "",
  },
  {
    title: "Contact Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
    render: (_, record) =>
      record
        ? `${record.country_code || ""} ${record.contact_number || ""}`.trim()
        : "N/A",
  },
  {
    title: "Referred From ID",
    align: "center",
    dataIndex: "refer_from",
    key: "refer_from",
    render: (referFrom) => referFrom || "",
  },
  {
    title: "From Name",
    align: "center",
    key: "fromName",
    render: (_, record) => record.from?.name || "N/A",
  },
  {
    title: "From Email",
    align: "center",
    key: "fromEmail",
    render: (_, record) => record.from?.email || "N/A",
  },
  {
    title: "From Contact",
    align: "center",
    key: "fromContact",
    render: (_, record) =>
      record.from
        ? `${record.from.country_code || ""} ${record.from.contact_number || ""
          }`.trim()
        : "N/A",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (createdAt) => {
      if (!createdAt) return "";
      // Format the date string to locale if you want, e.g.:
      return new Date(createdAt).toLocaleDateString();
    },
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => {
  //     const statusColors = {
  //       ongoing: "blue",
  //       paid: "green",
  //       closed: "gray",
  //       cancelled: "red",
  //     };
  //     const color = statusColors[status] || "default";
  //     return (
  //       <span
  //         style={{
  //           display: "inline-flex",
  //           alignItems: "center",
  //           padding: "4px 8px",
  //           border: "1px solid #d9d9d9",
  //           borderRadius: "10px",
  //         }}
  //       >
  //         <Badge color={color} text={ToFirstCapital(status)} />
  //       </span>
  //     );
  //   },
  // },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => (
  //     <Dropdown
  //       trigger={["click"]}
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="View">
  //             <Link to={`/referrals/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsReferralCommission = (handleStatusChange, canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country",
    align: "center",
    dataIndex: "country",
    key: "country",
    render: (country) => (country && country.country_name) || "N/A",
  },
  {
    title: "State",
    align: "center",
    dataIndex: "state",
    key: "state",
    render: (state) => (state && state.state_name) || "N/A",
  },
  {
    title: "City",
    align: "center",
    dataIndex: "city",
    key: "city",
    render: (city) => (city && city.city_name) || "N/A",
  },
  {
    title: "Unit",
    align: "center",
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: "Referral Amount",
    align: "center",
    dataIndex: "referral_amount",
    key: "referral_amount",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => new Date(date).toLocaleDateString(),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Link to={`/referral_commission/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
            {/* Add Edit or Delete if needed */}
            {/* Show Active only if status is NOT active */}
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {/* Show Inactive only if status is NOT inactive */}
            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
            {canEdit &&
              <Link to={`/referral_commission/edit/${record._id}`}>
                <Menu.Item key="edit">Edit</Menu.Item>
              </Link>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsFranchise = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Franchise ID",
    dataIndex: "franchise_id",
    key: "franchise_id",
    align: "center",
  },
  {
    title: "Brand Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
  },
  {
    title: "Organization Name",
    dataIndex: "organization_name",
    key: "organization_name",
    align: "center",
  },
  {
    title: "Primary Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
  },
  {
    title: "Contact Number",
    key: "primary_contact_number",
    align: "center",
    render: (_, record) =>
      `${record.primary_country_code || ""} ${record.primary_contact_number || ""
      }`,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "approved"
              ? "green"
              : status === "rejected"
                ? "red"
                : "gray"
          }
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/franchise/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="assign_builder">
              <Link to={`/franchise/assign-builder/${record._id}`}>
                Builder List
              </Link>
            </Menu.Item>
            <Menu.Item key="assign_builder_list">
              <Link to={`/franchise/assign-builder-list/${record._id}`}>
                Assigned Builder
              </Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsRewards = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Voucher",
    dataIndex: "voucher",
    key: "voucher",
    align: "center",
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  // {
  //   title: "Logo",
  //   dataIndex: "logo",
  //   key: "logo",
  //   align: "center",
  //   render: (logo) =>
  //     logo ? <img src={logo} alt="Logo" style={{ width: 50, height: 50 }} /> : "N/A",
  // },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) =>
      image ? (
        <img src={image} alt="Voucher" style={{ width: 50, height: 50, borderRadius: "50%" }} />
      ) : (
        "N/A"
      ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Primary Status",
    dataIndex: "primary",
    align: "center",
    key: "primary",
    render: (set_primary) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={set_primary ? "blue" : "gray"} // ✅ show primary in blue, not primary in gray
          text={set_primary ? "Primary" : "Not Primary"} // ✅ show label
        />
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "active"
              ? "green"
              : status === "inactive"
                ? "red"
                : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/rewards_voucher/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/rewards_voucher/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {/* If you have other relevant links for action, add here */}
            {record.status !== "active" && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {/* Show Inactive only if status is NOT inactive */}
            {record.status !== "inactive" && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}

            {!record.primary && (
              <Menu.Item
                key="Primary"
                onClick={() => handleStatusChange(record, "primary")}
              >
                Primary
              </Menu.Item>
            )}

            {record.primary && (
              <Menu.Item
                key="Remove Primary"
                onClick={() => handleStatusChange(record, "remove-primary")}
              >
                Remove Primary
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsPage = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (value) =>
      value
        ? value
          .split("_")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(" ")
        : "N/A",
  },
  {
    title: "Page Name",
    dataIndex: "pageName",
    key: "pageName",
    align: "center",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "PDF URL",
    dataIndex: "pdf_url",
    key: "pdf_url",
    align: "center",
    render: (url) =>
      url ? (
        <a href={url} target="_blank" rel="noreferrer">
          View PDF
        </a>
      ) : (
        "N/A"
      ),
  },
  {
    title: "Current Version",
    dataIndex: "curr_version",
    key: "curr_version",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/pages/view/${record.type}`}>View</Link>
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/pages/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRewardsPoints = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Minimum Value",
    dataIndex: "min_value",
    render: (val) => val ?? "N/A",
    align: "center",
  },
  {
    title: "Maximum Value",
    dataIndex: "max_value",
    key: "max_value",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   align: "center",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={status === "active" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       />
  //     </span>
  //   ),
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* If you have a view page for reward points, adjust link accordingly */}
            {/* <Menu.Item key="view">
              <Link to={`/reward-points/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            <Menu.Item key="view">
              <Link to={`/rewards_point/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {/* {record.status !== "active" && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}
            {record.status !== "inactive" && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )} */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsEmailList = (currentPage, pageSize, handleDelete, openEditModal) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit" onClick={() => openEditModal(record)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsOoraList = (currentPage, pageSize, handleDelete, openEditModal) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Plan Name",
    dataIndex: "plan_name",
    key: "plan_name",
    align: "center",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    render: (amount, record) => (
      <>
        {record.currency} {amount}
        {record.before_discount_amount && (
          <span style={{ textDecoration: "line-through", marginLeft: "5px", color: "#999" }}>
            {record.currency} {record.before_discount_amount}
          </span>
        )}
      </>
    ),
  },
  {
    title: "Currency",
    dataIndex: "currency",
    key: "currency",
    align: "center",
  },
  {
    title: "Most Popular",
    dataIndex: "is_most_popular",
    key: "is_most_popular",
    align: "center",
    render: (isMostPopular) => (
      <span style={{ color: isMostPopular ? "#1890ff" : "#999" }}>
        {isMostPopular ? "⭐ Yes" : "No"}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => {
      const isActive = status === "active";
      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "10px",
            backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
            border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
            color: isActive ? "#52c41a" : "#ff4d4f",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
              marginRight: "6px",
            }}
          />
          {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
        </div>
      );
    },
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit" onClick={() => openEditModal(record)}>
              Edit
            </Menu.Item>
            <Menu.Item
              key="status"
              onClick={() => handleDelete(record._id)}
              style={{ color: record.status === "active" ? "#ff4d4f" : "#52c41a" }}
            >
              {record.status === "active" ? "Deactivate" : "Activate"}
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsCommingSoonCitiesList = (currentPage, pageSize, handleDelete, openEditModal) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "City Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Image",
    dataIndex: "url",
    key: "url",
    align: "center",
    render: (image) => image ? (
      <img
        src={image}
        alt="Review"
        style={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          objectFit: 'contain',
          border: '1px solid #e0e0e0'
        }}
      />
    ) : (
      <span style={{ color: '#999' }}>No Image</span>
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => text?.substring(0, 50) + (text?.length > 50 ? "..." : ""),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit" onClick={() => openEditModal(record)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];



export const columnsReviewRatingList = (currentPage, pageSize, openViewModal, openEditModal) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Profession",
    dataIndex: "profession",
    key: "profession",
    align: "center",
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    align: "center",
    render: (rating) => {
      const filledStars = Math.floor(rating || 0);

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {[...Array(filledStars)].map((_, i) => (
            <span
              key={`filled-${i}`}
              style={{
                color: "#ffa500",
                fontSize: '20px'
              }}
            >
              ⭐
            </span>
          ))}

          {/* Empty Stars */}
          {[...Array(5 - filledStars)].map((_, i) => (
            <span
              key={`empty-${i}`}
              style={{
                color: "#ccc",
                fontSize: '20px'
              }}
            >
              ☆
            </span>
          ))}

          {/* <span style={{ marginLeft: 8, fontSize: 14, color: "#666" }}>
            ({rating})
          </span> */}
        </div>
      );
    },
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) => image ? (
      <img
        src={image}
        alt="Review"
        style={{
          width: 50,
          height: 50,
          borderRadius: 8,
          objectFit: 'cover',
          border: '1px solid #e0e0e0'
        }}
      />
    ) : (
      <span style={{ color: '#999' }}>No Image</span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="view"
              onClick={() => openViewModal(record)}
            >
              View
            </Menu.Item>
            <Menu.Item key="edit" onClick={() => openEditModal(record)}>
              Edit
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsAgentProfitRangeList = (currentPage, pageSize, handleDelete, openEditModal) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Profit Range (%)",
    dataIndex: "agent_profit_range",
    key: "agent_profit_range",
    align: "center",
    render: (value) => `${value}%`,
  },
  {
    title: "Min Price",
    dataIndex: "min_price",
    key: "min_price",
    align: "center",
    render: (value) => `₹${value?.toLocaleString() || '0'}`,
  },
  {
    title: "Max Price",
    dataIndex: "max_price",
    key: "max_price",
    align: "center",
    render: (value) => `₹${value?.toLocaleString() || '0'}`,
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",

    render: (value) => (
      <span style={{
        background: value === 'luxury' ? '#fff2e8' :
          value === 'premium' ? '#f9f0ff' :
            value === 'standard' ? '#f6ffed' :
              value === 'basic' ? '#e6f7ff' : '#f5f5f5',
        color: value === 'luxury' ? '#d46b08' :
          value === 'premium' ? '#722ed1' :
            value === 'standard' ? '#52c41a' :
              value === 'basic' ? '#1890ff' : '#000',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500
      }}>
        {value?.toUpperCase() || 'N/A'}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit" onClick={() => openEditModal(record)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRewardsUserPoints = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Name",
    dataIndex: "name", // Note: Keep as per schema, consider fixing typo to contact_number in schema
    key: "name",
    align: "center",
  },
  {
    title: "Contact Number",
    dataIndex: "contact_number", // Note: Keep as per schema, consider fixing typo to contact_number in schema
    key: "contact_number",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "center",
  },
  // {
  //   title: "Start Date",
  //   dataIndex: "start_at",
  //   key: "start_at",
  //   align: "center",
  //   render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  // },
  // {
  //   title: "Expiry Date",
  //   dataIndex: "expire_at",
  //   key: "expire_at",
  //   align: "center",
  //   render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  // },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   align: "center",
  //   render: (status) => (
  //     <Badge
  //       color={status === "active" ? "green" : "red"}
  //       text={ToFirstCapital(status)}
  //     />
  //   ),
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit">
              <Link to={`/rewards_user_point/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Status toggles can be re-enabled if needed */}
            {/* 
            {record.status !== "active" && (
              <Menu.Item key="Active" onClick={() => handleStatusChange(record, "active")}>
                Activate
              </Menu.Item>
            )}
            {record.status !== "inactive" && (
              <Menu.Item key="Inactive" onClick={() => handleStatusChange(record, "inactive")}>
                Deactivate
              </Menu.Item>
            )}
             */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsBuildersRanking = (currentPage, pageSize, handleUpdateRanking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.ranking || 999999) - (b.ranking || 999999),
  },
  {
    title: "Builder Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Organization",
    dataIndex: "organization_name",
    key: "organization_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Contact Number",
    dataIndex: "primary_contact_number",
    key: "primary_contact_number",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "account_status",
    align: "center",
    render: (status) => (
      <span
        style={{
          color: status === "approved" ? "#52c41a" : "#faad14",
          backgroundColor: status === "approved" ? "#f6ffed" : "#fffbe6",
          padding: "2px 8px",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: 500
        }}
      >
        {status?.toUpperCase() || "N/A"}
      </span>
    ),
    filters: [
      { text: "Requested", value: "requested" },
      { text: "Approved", value: "approved" },
    ],
    onFilter: (value, record) => record.account_status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsProjectRanking = (currentPage, pageSize, handleUpdateRanking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.ranking || 999999) - (b.ranking || 999999),
  },
  {
    title: "Project ID",
    dataIndex: "project_id",
    key: "project_id",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    key: "project_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => {
      const statusLower = status?.toLowerCase();
      const config = {
        approved: { color: "#52c41a", bg: "#f6ffed" },
        published: { color: "#52c41a", bg: "#f6ffed" },
        sold: { color: "#52c41a", bg: "#f6ffed" },
        requested: { color: "#faad14", bg: "#fffbe6" },
        unpublished: { color: "#faad14", bg: "#fffbe6" },
        declined: { color: "#ff4d4f", bg: "#fff2f0" },
      };
      const style = config[statusLower] || { color: "#000", bg: "#f5f5f5" };
      return (
        <span
          style={{
            color: style.color,
            backgroundColor: style.bg,
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {status?.toUpperCase() || "N/A"}
        </span>
      );
    },
    filters: [
      { text: "Requested", value: "REQUESTED" },
      { text: "Approved", value: "APPROVED" },
      { text: "Declined", value: "DECLINED" },
      { text: "Unpublished", value: "UNPUBLISHED" },
      { text: "Published", value: "PUBLISHED" },
      { text: "Sold", value: "SOLD" },
    ],
    onFilter: (value, record) => record.status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsDoneRewardsUserPoints = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
    render: (text) => (text ? text : "N/A"),
  },
  {
    title: "Contact Number",
    key: "user_contact_number",
    align: "center",
    render: (record) => record.contact_number || "N/A",
  },
  {
    title: "Email",
    key: "user_email",
    align: "center",
    render: (record) => record.email || "N/A",
  },
  {
    title: "Voucher Code",
    key: "voucher_code",
    align: "center",
    render: (record) => record.voucher?.voucher || "N/A",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/done_user_rewards/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Uncomment and use handleStatusChange if needed */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsFinancePartners = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Logo",
    dataIndex: "logo",
    key: "logo",
    align: "center",
    render: (logo) =>
      logo ? (
        <img
          src={logo}
          alt="Logo"
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <span>N/A</span>
      ),
  },
  {
    title: "Company Name",
    dataIndex: "company_name",
    key: "company_name",
    align: "center",
  },
  {
    title: "Contact Number",
    key: "contact_number",
    align: "center",
    render: (_, record) =>
      `${record.country_code || ""} ${record.contact_number || ""}`,
  },
  // {
  //   title: "Address",
  //   dataIndex: "address",
  //   key: "address",
  //   align: "center",
  // },
  // {
  //   title: "Country",
  //   dataIndex: ["country", "country_name"],
  //   key: "country",
  //   align: "center",
  // },
  // {
  //   title: "State",
  //   dataIndex: ["state", "state_name"],
  //   key: "state",
  //   align: "center",
  // },
  // {
  //   title: "City",
  //   dataIndex: ["city", "city_name"],
  //   key: "city",
  //   align: "center",
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "active"
              ? "green"
              : status === "inactive"
                ? "red"
                : "gray"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/finance_partners/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/finance_partners/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }

            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCancellationPolicies = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Policy",
    dataIndex: "policy",
    key: "policy",
    align: "left",
    render: (policy) => (
      <Tooltip
        placement="top"
        title={
          Array.isArray(policy)
            ? policy.join("\n")
            : typeof policy === "string"
              ? policy
              : ""
        }
      >
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 300,
            cursor: "pointer",
          }}
        >
          {Array.isArray(policy)
            ? policy[0]
            : typeof policy === "string"
              ? policy
              : "N/A"}
          {Array.isArray(policy) && policy.length > 1 ? "..." : ""}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (type) => ToFirstCapital(type),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/cancellation_policies/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/cancellation_policies/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* Add more actions as needed, e.g., Edit, Delete */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const assignBuilderColumns = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Builder ID",
    dataIndex: "builder_id",
    key: "builder_id",
    align: "center",
  },
  {
    title: "Brand Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Primary Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Contact Number",
    key: "primary_contact_number",
    align: "center",
    render: (_, record) =>
      `${record.primary_country_code || ""} ${record.primary_contact_number || ""
      }`,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "account_status",
    align: "center",
    render: (status) => (
      <Badge
        color={
          status === "approved"
            ? "green"
            : status === "inactive"
              ? "red"
              : "gray"
        }
        text={ToFirstCapital(status)}
      />
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/builder/view/${record._id}`}>View</Link>
            </Menu.Item>

            {record.account_status !== "approved" && (
              <Menu.Item
                key="approve"
                onClick={() => handleStatusChange(record, "approved")}
              >
                Approve
              </Menu.Item>
            )}

            {record.account_status !== "inactive" && (
              <Menu.Item
                key="inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactivate
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="circle" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsProjectsAdmin = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_name",
  },
  {
    title: "Project Type",
    align: "center",
    dataIndex: "project_type",
    render: (record) => (record ? record.name : ""),
  },
  {
    title: "Location",
    align: "center",
    dataIndex: "street_address",
    ellipsis: true,
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "approved" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu className="custom-action-dropdown">
            <Menu.Item key="View">
              <Link to={`/manage_projects/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="view_project">
              <Link to={`/manage_projects/view/catalogue/${record._id}`}>
                View Project Catalogue
              </Link>
            </Menu.Item>
            <Menu.Item key="AddProperty">
              <Link to={`/manage_projects/add_property/${record._id}`}>
                Add Property
              </Link>
            </Menu.Item>
            <Menu.Item key="view_enquiry">
              <Link to={`/manage_projects/enquiries/${record._id}`}>
                View Enquiries
              </Link>
            </Menu.Item>
            {/* {record.status !== "published" ? (
              <Link to={`/manage_projects/edit/${record._id}`}>
                <Menu.Item key="edit">Edit Project</Menu.Item>
              </Link>
            ) : null} */}
            <Menu.Item
              key="edit"
              onClick={() => {
                record?.status === "published"
                  ? toast.error(
                    "Can't Edit a published project, Change status!!"
                  )
                  : (window.location.href = `/manage_projects/edit/${record._id}`);
              }}
            >
              Edit Project
            </Menu.Item>
            <Menu.Item key="show_price_list">
              <Link to={`/manage_projects/show_price_list/${record._id}`}>
                show Price list
              </Link>
            </Menu.Item>
            <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/project/remove", record._id);
                window.location.reload();
              }}
              key="delete"
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsEnquiry = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.project_name : "No Data"),
  },
  {
    title: "Builder",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.brand_name : "No Data"),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "User Contact Number",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.contact_number : "No Data"),
  },
  {
    title: "User Email",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.email : "No Data"),
  },
  {
    title: "Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", 
  //         borderRadius: "10px", 
  //       }}
  //     >
  //       <Badge
  //         color={status === "closed" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       />
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item>
              <Link to={`/enquiry/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item
              style={{ color: "red" }}
              onClick={() => {
                DeleteFunction("/enquiries/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsUserEnquiry = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.project_name : "No Data"),
  },
  {
    title: "Builder",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.brand_name : "No Data"),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "User Contact Number",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.contact_number : "No Data"),
  },
  {
    title: "User Email",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.email : "No Data"),
  },
  {
    title: "Number of Views",
    align: "center",
    dataIndex: "count",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (record) => (record ? new Date(record).toLocaleString() : ""),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item>
              <Link to={`/enquiry/user-view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsProperties = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Property Id",
    dataIndex: "property_id",
    key: "property_id",
    align: "center",
  },
  {
    title: "Property Type",
    dataIndex: "category",
    key: "category",
    align: "center",
    render: (record) => (record ? record?.name : "N/A"),
  },
  {
    title: "Project Type",
    dataIndex: "project_type",
    key: "property_id",
    align: "center",
    render: (record) => record?.name || "No Data",
  },
  {
    title: "Project Name",
    dataIndex: "project",
    key: "project",
    align: "center",
    render: (record) => {
      return record?.project_name || "No Data";
    },
  },
  {
    title: "Type",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    render: (record) => {
      return record?.name || "No Data";
    },
  },
  {
    title: "Added By",
    dataIndex: "added_by",
    key: "added_by",
    align: "center",
  },
  {
    title: "Location",
    dataIndex: "street_address",
    key: "project",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },

  {
    title: "Construction Status",
    key: "construction_status",
    align: "center",
    dataIndex: "construction_status",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "published" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/manage_properties/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
            {/* {record?.added_by === "admin" &&
              record?.status?.trim().toLowerCase() !== "published" && (
                <Menu.Item key="view">
                  <Link to={`/manage_properties/edit/${record._id}`}>
                    Edit Property
                  </Link>
                </Menu.Item>
              )} */}
            <Menu.Item
              key="edit"
              onClick={() => {
                record?.status === "published" || record?.added_by !== "admin"
                  ? toast.error(
                    "Cannot edit a Published and Builder's added property!!"
                  )
                  : (window.location.href = `/manage_properties/edit/${record._id}`);
              }}
            >
              Edit Property
            </Menu.Item>

            {record?.added_by === "admin" ? (
              <Menu.Item
                style={{ color: "red" }}
                onClick={async () => {
                  await DeleteFunction("/property/remove", record._id);
                  window.location.reload();
                }}
                key="view"
              >
                Delete Property
              </Menu.Item>
            ) : null}
          </Menu>
        }
      >
        <Button
          shape="square"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsTeams = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    width: 80,

    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Employee ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  {
    title: "Designation",
    align: "center",
    key: "designation",
    dataIndex: "designation",
  },
  {
    title: "Department",
    align: "center",
    key: "department",
    dataIndex: "department",
  },
  {
    title: "Joining Data",
    align: "center",
    // key:"live_projects",
    dataIndex: "joining_date",
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "BLOCK" ? "red" : "green"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {/* Show Active only if status is NOT active */}
            {record.status !== "BLOCK" && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )}

            {/* Show Inactive only if status is NOT inactive */}
            {record.status !== "UNBLOCK" && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];
export const columnsAgents = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    // width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Agent Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Agent Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Agent Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Agent ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  // {
  //   title: "Designation",
  //   align: "center",
  //   key: "designation",
  //   dataIndex: "designation",
  // },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  // },
  {
    title: "Joining Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Profile Status",
    align: "center",
    key: "profile_status",
    dataIndex: "profile_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status && status !== "BLOCK" ? "green" : "red"}
          text={status ? ToFirstCapital(status) : "N/A"}
        />
      </span>
    ),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   key: "status",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", // Light gray border
  //         borderRadius: "10px", // Rounded edges
  //       }}
  //     >
  //       <Badge
  //         color={status === "BLOCK" ? "red" : "green"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {/* Show Active only if status is NOT active */}
            {/* {record.status !== "BLOCK" && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )} */}

            {/* Show Inactive only if status is NOT inactive */}
            {/* {record.status !== "UNBLOCK" && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )} */}

            <Menu.Item key="view">
              <Link to={`/agent/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUnits = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    Flex: "nowrap",
    dataIndex: "",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Unit Type",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Category",
    align: "center",
    dataIndex: "category_name",
    key: "category_name",
  },
  {
    title: "Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/furnishing/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/furnishing/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/unit/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBookings = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: "booking_id",
    key: "booking_id",
  },
  {
    title: "User name",
    align: "center",
    dataIndex: "user",
    key: "user_name",
    render: (record) => record?.name || "No Data",
  },
  {
    title: "Email Address",
    align: "center",
    dataIndex: "user",
    key: "email",
    render: (record) => record?.email || "No Data",
  },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "user",
    key: "contact_number",
    render: (record) => record?.contact_number || "No Data",
  },
  {
    title: "User Documents",
    align: "center",
    dataIndex: "user",
    key: "documents",
    ellipsis: false, // <== Important: prevents truncation
    render: (record) => {
      if (
        !record?.documents ||
        !Array.isArray(record.documents) ||
        record.documents.length === 0
      )
        return (
          <p style={{ color: "red" }}>No documents</p>
        );

      return (
        <div style={{ width: "100%", cursor: "pointer" }}>
          <Dropdown
            overlay={
              <Menu>
                {record.documents.map((doc, index) => (
                  <Menu.Item key={index}>
                    <a href={doc.url} target="_blank" rel="noopener noreferrer">
                      {doc.name}
                    </a>
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <span style={{ color: "blue" }}>View Documents</span>
          </Dropdown>
        </div>
      );
    },
    // render: (record) => {
    //   if (Array.isArray(record.documents) && record.documents.length === 0)
    //     return (
    //       <p style={{ color: "red" }}>No documents uploaded by the user</p>
    //     );
    //   return (
    //     <div style={{ width: "100%", cursor: "pointer" }}>
    //       <Dropdown
    //         overlay={
    //           <Menu>
    //             {Array.isArray(record.documents) &&
    //             record.documents.length > 0 ? (
    //               record.documents.map((doc, index) => (
    //                 <Menu.Item key={index}>
    //                   <a
    //                     href={doc.url}
    //                     target="_blank"
    //                     rel="noopener noreferrer"
    //                   >
    //                     {doc.name}
    //                   </a>
    //                 </Menu.Item>
    //               ))
    //             ) : (
    //               <Menu.Item disabled>
    //                 No documents uploaded by the user
    //               </Menu.Item>
    //             )}
    //           </Menu>
    //         }
    //         trigger={["click"]}
    //       >
    //         <span style={{ color: "blue" }}>View Documents</span>
    //       </Dropdown>
    //     </div>
    //   );
    // },
  },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "created_at",
    key: "booking_date",
    render: (record) => {
      const dateObj = new Date(record);
      return dateObj.toLocaleDateString();
    },
  },
  {
    title: "Time",
    align: "center",
    dataIndex: "created_at",
    key: "Time",
    render: (createdAt) => {
      if (!createdAt) return "";
      const date = new Date(createdAt);
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
  },
  {
    title: "Project",
    align: "center",
    dataIndex: "project",
    key: "project",
    render: (record) => record?.project_name || "No Data",
  },
  {
    title: "Booking Status",
    align: "center",
    dataIndex: "booking_status",
    key: "project",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    key: "project",
  },
  {
    title: "Payment Type",
    align: "center",
    dataIndex: "booked_property",
    key: "payment_type",
    render: (record) => record?.plan_type || "No Data",
  },
  {
    title: "Booked Unit",
    align: "center",
    dataIndex: "properties",
    key: "booked_unit",
    render: (record) => record?.length || "0",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/bookings/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBookingsPayment = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: "booking_id",
    key: "booking_id",
  },
  {
    title: "User name",
    align: "center",
    dataIndex: "user",
    key: "user_name",
    render: (user) => user?.name || "No Data",
  },
  {
    title: "Email Address",
    align: "center",
    dataIndex: "user",
    key: "email",
    render: (user) => user?.email || "No Data",
  },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "user",
    key: "contact_number",
    render: (user) => user?.contact_number || "No Data",
  },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "created_at",
    key: "booking_date",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "No Data"),
  },
  {
    title: "Time",
    align: "center",
    dataIndex: "created_at",
    key: "time",
    render: (date) => (date ? new Date(date).toLocaleTimeString() : "No Data"),
  },
  {
    title: "Project",
    align: "center",
    dataIndex: "project",
    key: "project",
    render: (project) => project?.project_name || "No Data",
  },
  {
    title: "Booked Unit",
    align: "center",
    dataIndex: "properties",
    key: "booked_unit",
    render: (properties) =>
      Array.isArray(properties) ? properties.length : "No Data",
  },
  {
    title: "Booking Amount",
    align: "center",
    dataIndex: "booking_amount",
    key: "booking_amount",
    render: (amount) =>
      amount !== undefined && amount !== null
        ? `₹${amount.toLocaleString()}`
        : "No Data",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    key: "payment_status",
    render: (status) => status || "No Data",
  },
  {
    title: "Refund Status",
    align: "center",
    dataIndex: "refund_status",
    key: "refund_status",
    render: (status) => status || "No Data",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/bookings/payment-executive/view/${record._id}`}>
                View
              </Link>
            </Menu.Item>
            <Menu.Item key="chat">
              <Link to={`/chat_and_support/pay_exec/${record._id}`}>Chat</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsPages = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Created Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Type",
    align: "center",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/pages/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/pages/delete/${record._id}`}>delete</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAds = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Description",
    align: "center",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Banner",
    align: "center",
    dataIndex: "cover_photo",
    key: "cover_photo",
    render: (_, record, index) => (
      <img
        key={index}
        style={{ height: "20px", width: "50px" }}
        alt=""
        src={
          record?.cover_photo || require("../Global Icons/AlternateImage.png")
        }
      ></img>
    ),
  },
  {
    title: "Type",
    align: "center",
    dataIndex: "type",
    key: "type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item onClick={() => { }} key="view">
              <Link to={``}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={``}>Edit</Link>
            </Menu.Item>
            <Menu.Item key="delete">
              <Link to={``}>Delete</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsDeals = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    key: "project_name",
    render: (_, record, index) =>
      Array.isArray(record?.project) ? record?.project[0]?.project_name : "N/A",
  },
  {
    title: "Deal Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "created_at",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Discount Type",
    align: "center",
    dataIndex: "discount_type",
    key: "discount_type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Value",
    align: "center",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/deals/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];
export const columnsDealsList = (handleStatusChange) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    key: "project_name",
    render: (_, record, index) =>
      Array.isArray(record?.project) ? record?.project[0]?.project_name : "N/A",
  },
  {
    title: "Deal Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    dataIndex: "image",
    align: "center",
    key: "image",
    render: (text) => (
      <img
        src={text}
        alt="item"
        style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "40px" }}
      />
    ),
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "created_at",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Discount Type",
    align: "center",
    dataIndex: "discount_type",
    key: "discount_type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Value",
    align: "center",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/deals/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/deals/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Item
              key="Active"
              onClick={() => handleStatusChange(record, "active")}
            >
              Active
            </Menu.Item>
            <Menu.Item
              key="Inactive"
              onClick={() => handleStatusChange(record, "inactive")}
            >
              Inactive
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCurrencyList = (handleStatusChange) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country Name",
    align: "center",
    dataIndex: "name",
    key: "country_name",
  },
  {
    title: "Currency",
    align: "center",
    dataIndex: "currency",
    key: "currency",
  },
  {
    title: "Tax (%)",
    align: "center",
    dataIndex: "tax",
    key: "tax",
  },
  {
    title: "Booking Amount %",
    align: "center",
    dataIndex: "booking_amount_percent",
    key: "booking_amount_percent",
  },
  {
    title: "Max Booking Amount",
    align: "center",
    dataIndex: "max_booking_amount",
    key: "max_booking_amount",
  },
  {
    title: "Min Booking Amount",
    align: "center",
    dataIndex: "min_booking_amount",
    key: "min_booking_amount",
  },
  {
    title: "Min Booking Amount Kiosk",
    align: "center",
    dataIndex: "min_booking_amount_kiosk",
    key: "min_booking_amount_kiosk",
  },
  {
    title: "Max Booking Amount Kiosk",
    align: "center",
    dataIndex: "max_booking_amount_kiosk",
    key: "max_booking_amount_kiosk",
  },
  {
    title: "Max Property Price",
    align: "center",
    dataIndex: "max_property_price",
    key: "max_property_price",
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           {/* Customize actions as needed */}
  //           <Menu.Item key="edit">
  //             {/* Example Edit Link, update path as appropriate */}
  //             <Link to={`/currency/edit/${record._id}`}>Edit</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];


export const columnsConsultant = (getCellClick) => [
  { title: "Sr No.", render: (_, __, index) => index + 1 },
  {
    title: "Name",
    align: "center",
    dataIndex: "first_name",
    key: "first_name",
  },
  {
    title: "Email",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Country Code",
    align: "center",
    key: "country_code",
    dataIndex: "country_code",
  },
  {
    title: "Phone",
    align: "center",
    key: "conact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Id",
    align: "center",
    key: "consultant_id",
    dataIndex: "consultant_id",
  },
  {
    title: "Created",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Actions",
    align: "center",
    dataIndex: "action",
    key: "action",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/Consultants/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsPayments = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Payment ID",
    align: "center",
    dataIndex: "payment_id",
    key: "payment_id",
  },
  {
    title: "Payment Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
    render: (amount, record) => {
      const currencySymbol = record.currency === "INR" ? "₹" : record.currency;
      return `${currencySymbol} ${amount}`;
    },
  },
  // {
  //   title: "Booking Amount",
  //   align: "center",
  //   dataIndex: "booking_amount",
  //   key: "booking_amount",
  //   render: (record) => record?.toFixed(2),
  // },
  // {
  //   title: "Project Name",
  //   align: "center",
  //   dataIndex: "project",
  //   key: "project",
  //   render: (record) => record.project_name || "No Data",
  // },
  {
    title: "Payment Type",
    align: "center",
    dataIndex: "payment_type",
    key: "payment_type",
  },
  // {
  //   title: "User Name",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "user",
  //   render: (record) => record?.name || "No Data",
  // },
  // {
  //   title: "User Contact Number",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "user",
  //   render: (record) => record?.contact_number || "No Data",
  // },

  {
    title: "Status",
    align: "center",
    dataIndex: "payment_status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "pending" ? "red" : "green"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/payments/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRequestPayments = (currentPage, pageSize, handleStatusChange, openRejectPopup, openApprovePopup, openViewReasonPopup) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: ["booking", "booking_id"],
    key: "booking_id",
  },
  {
    title: "Payment Request Date",
    align: "center",
    dataIndex: "requested_at",
    key: "requested_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "refund_amount",
    key: "refund_amount",
    render: (refund_amount, record) => {
      const currencySymbol = record.booking.currency === "INR" ? "₹" : record.booking.currency;
      return `${currencySymbol} ${refund_amount}`;
    },
  },
  {
    title: "Refund Reason",
    align: "center",
    dataIndex: "refund_reason_from_user",
    key: "refund_reason_from_user",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "requested" ? "blue" : status === "rejected" ? "red" : "green"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {record.status !== "approved" && record.status !== "requested" && (
              <Menu.Item key="view" onClick={() => openViewReasonPopup(record)}>
                View Reason
              </Menu.Item>
            )}
            {record.status !== "rejected" && record.status !== "requested" && (
              <Menu.Item key="no-reason">
                No Reason
              </Menu.Item>
            )}

            {record.status !== "approved" && record.status !== "rejected" && (
              <Menu.Item
                key="Approved"
                onClick={() => openApprovePopup(record)}
              >
                Approved
              </Menu.Item>
            )}

            {record.status !== "rejected" && record.status !== "approved" && (
              <Menu.Item
                key="Rejected"
                onClick={() => openRejectPopup(record)} // Open popup instead of direct call
              >
                Rejected
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRefunds = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Transaction ID",
    align: "center",
    dataIndex: "transaction_id",
    key: "payment_id",
  },
  {
    title: "Payment Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
    render: (record) => record?.toFixed(2),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
    render: (record) => record?.name || "N/A",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "approved" || status === "completed" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsNews = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "News ID",
    align: "center",
    dataIndex: "news_id",
    key: "news_id",
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  // {
  //   title: "Start Date",
  //   align: "center",
  //   dataIndex: "start_date",
  //   key: "start_date",
  //   render: (date) => {
  //     return date ? DateToLocale(date) : "N/A";
  //   },
  // },
  // {
  //   title: "End Date",
  //   align: "center",
  //   dataIndex: "end_date",
  //   key: "end_date",
  //   render: (date) => {
  //     return date ? DateToLocale(date) : "N/A";
  //   },
  // },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/news_and_articles/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/news_and_articles/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Item
              style={{ color: "red" }}
              key="Delete"
              onClick={async () => {
                await DeleteFunction("/news/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsNewsBrand = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Brand Logo",
    dataIndex: "brand_logo",
    key: "brand_logo",
    align: "center",
    render: (image) =>
      image ? (
        <img src={image} alt="Voucher" style={{ width: 40, height: 40, borderRadius: "40px", objectFit: "contain", border: "1px solid" }} />
      ) : (
        "N/A"
      ),
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 300,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Company Name",
    align: "center",
    dataIndex: "company_name",
    key: "company_name",

    render: (text) => (
      <Tooltip placement="top" title={text || "N/A"}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 350,
          }}
        >
          {text || "N/A"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Brand Type",
    align: "center",
    dataIndex: "type",
    render: (type) => type
      ? type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      : 'N/A'
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) =>
      date ? new Date(date).toLocaleString() : "N/A",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/fa_brands/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/fa_brands/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              key="Delete"
              onClick={async () => {
                await DeleteFunction("/news_brand/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsBrands = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Brand Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img
        src={record ? record : require("../Global Icons/Approve.svg")}
        style={{ width: "50px", height: "50px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsSurroundingIndustries = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Surrounding Industry Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img
        src={record ? record : require("../Global Icons/Approve.svg")}
        style={{ width: "50px", height: "50px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsInvites = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Event",
    align: "center",
    dataIndex: "event",
    key: "event",
    render: (record) => record?.event_name || "No Data",
  },
  {
    title: "User",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "start_date",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Guests",
    align: "center",
    dataIndex: "guest_list",
    key: "guest_list",
    render: (record) => (record ? record.length : "0"),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={status === "active" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/invites/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/invite/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCabs = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Cab Category",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img style={{ maxHeight: "50px" }} alt="" src={record}></img>
    ),
  },
  {
    title: "Country",
    align: "center",
    dataIndex: "country",
    key: "country",
    render: (record) => (record ? record.country_name : "N/A"),
  },
  {
    title: "Rate per Unit",
    align: "center",
    dataIndex: "rate_per_unit",
    key: "start_date",
  },
  {
    title: "Round Trip Rate per Unit",
    align: "center",
    dataIndex: "round_trip_rate_per_unit",
    key: "round_trip_rate_per_unit",
    render: (value) => value || 0,
  },
  {
    title: "Rate per unit measure In",
    align: "center",
    dataIndex: "rate_per_unit_measure_in",
    key: "rate_per_unit_in",
  },
  {
    title: "Currency",
    align: "center",
    dataIndex: "currency",
    key: "currency",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/cab_settings/view/${record._id}`}>
                View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/cab_settings/edit/${record._id}`}>
                  Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/cab-setting/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu >
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown >
    ),
  },
];

export const columnsAdmins = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Created On",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Contact Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
  },
  {
    title: "Role",
    align: "center",
    dataIndex: "role",
    key: "role",
    render: (role) => ToFirstCapital(role),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit">
              <Link to={`/manage_admins/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Item key="view">
              <Link to={`/manage_admins/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/admin/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsAccessList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Admin ID",
    align: "center",
    dataIndex: "admin_id",
    key: "admin_id",
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    align: "center",
    dataIndex: "role",
    key: "role",
    render: (role) => ToFirstCapital(role),
  },
  {
    title: "Department",
    align: "center",
    dataIndex: "department",
    key: "department",
    render: (dept) => ToFirstCapital(dept || "N/A"),
  },
  {
    title: "Designation",
    align: "center",
    dataIndex: "designation",
    key: "designation",
  },
  {
    title: "Access Code",
    align: "center",
    dataIndex: "access_code",
    key: "access_code",
    render: (codes) => codes?.join(", ") || "None",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "block" || status === "unblock" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit">
              <Link to={`/manage_admins/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Item key="view">
              <Link to={`/manage_admins/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/admin/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUserAppointmentList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },

  {
    title: "User ID",
    align: "center",
    render: (_, record) => record?.user?.user_id || "N/A",
  },

  {
    title: "User Name",
    align: "center",
    render: (_, record) => record?.user?.name || "N/A",
  },

  {
    title: "User Email",
    align: "center",
    render: (_, record) => record?.user?.email || "N/A",
  },

  {
    title: "Contact",
    align: "center",
    render: (_, record) =>
      record?.user
        ? `${record.user.country_code || ""} ${record.user.contact_number || ""}`
        : "N/A",
  },

  {
    title: "Agent Name",
    align: "center",
    render: (_, record) =>
      record?.agent?.length > 0 ? record.agent[0].name : "Not Assigned",
  },

  {
    title: "City",
    align: "center",
    render: (_, record) =>
      record?.cities?.length > 0
        ? record.cities.map((c) => c.city_name).join(", ")
        : "N/A",
  },

  {
    title: "Appointment Date",
    align: "center",
    dataIndex: "appointment_date",
    render: (date) =>
      date ? new Date(date).toLocaleDateString() : "N/A",
  },

  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "accepted"
              ? "orange"
              : status === "requested"
                ? "blue"
                : status === "ontheway"
                  ? "yellow"
                  : status === "declined" || status === "cancelled"
                    ? "red"
                    : "green"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },

  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) =>
      date ? new Date(date).toLocaleString() : "N/A",
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/home_visit/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUserPaymentList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },

  {
    title: "User ID",
    align: "center",
    dataIndex: "user_id",
    render: (id) => id || "N/A",
  },

  {
    title: "User Name",
    align: "center",
    dataIndex: "user_name",
    render: (name) => name || "N/A",
  },

  {
    title: "User Email",
    align: "center",
    dataIndex: "user_email",
    render: (email) => email || "N/A",
  },

  {
    title: "Booking Amount",
    align: "center",
    dataIndex: "booking_amount",
    render: (amount) => (
      <span style={{
        background: amount === 0 ? '#f6ffed' : 'rgb(176 225 255)',
        color: amount === 0 ? '#52c41a' : '#00438a',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500
      }}>
        {amount === 0 ? 'FREE' : `₹${amount || 0}`}
      </span>
    ),
  },

  {
    title: "Appointment Date",
    align: "center",
    dataIndex: "appointment_date",
    render: (date) =>
      date ? new Date(date).toLocaleDateString() : "N/A",
  },

  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "pending"
              ? "blue"
              : status === "completed"
                ? "green"
                : status === "failed" || status === "refunded"
                  ? "red"
                  : "orange"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },

  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "accepted"
              ? "orange"
              : status === "requested"
                ? "blue"
                : status === "ontheway"
                  ? "yellow"
                  : status === "declined" || status === "cancelled"
                    ? "red"
                    : "green"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
];

